import React, { useState } from "react";
import { toast } from "sonner";
import { MagnifyingGlass } from "@phosphor-icons/react";
import api from "@/lib/api";
import { US_STATES } from "@/pages/landing/QuizForm";
import { FIRST_STEP } from "@/pages/landing/caseFunnel/caseContent";
import { FUNNEL_OPTIONS } from "@/lib/funnelOptions";

const SELECT = "border-2 border-black bg-white px-2 py-1 text-[11px]";

export const MatchCheckPanel = () => {
  const [q, setQ] = useState({ slug: "truck", state: "GA", case_type: "" });
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const set = (k, v) => { setQ((p) => ({ ...p, [k]: v })); setRes(null); };
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/global-funnels/match-check", { ...q, case_type: q.case_type || null });
      setRes(data);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Couldn't check matching");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="border-2 border-black bg-zinc-50 p-2 mb-3" data-testid="match-check-panel">
      <div className="flex flex-wrap items-center gap-2">
        <span className="label-mono">Who would get this lead?</span>
        <select className={SELECT} value={q.slug} onChange={(e) => set("slug", e.target.value)} data-testid="match-check-funnel">
          {FUNNEL_OPTIONS.map((f) => <option key={f.slug} value={f.slug}>{f.title}</option>)}
        </select>
        <select className={SELECT} value={q.state} onChange={(e) => set("state", e.target.value)} data-testid="match-check-state">
          {US_STATES.map(([c, n]) => <option key={c} value={c}>{n}</option>)}
        </select>
        {q.slug === "injury" && (
          <select className={SELECT} value={q.case_type} onChange={(e) => set("case_type", e.target.value)} data-testid="match-check-case-type">
            <option value="">Any case type</option>
            {FIRST_STEP.injury.options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        )}
        <button type="button" onClick={run} disabled={busy} data-testid="match-check-run"
                className="border-2 border-black bg-black text-white px-2 py-1 text-[10px] uppercase tracking-widest inline-flex items-center gap-1 disabled:opacity-40">
          <MagnifyingGlass size={11} weight="bold" /> {busy ? "Checking\u2026" : "Check"}
        </button>
      </div>
      {res && (
        <div className="mt-2 flex flex-wrap items-center gap-1.5 text-[11px]" data-testid="match-check-result">
          {res.marketplace ? (
            <span data-testid="match-check-marketplace">No buyer matches &mdash; this lead goes to the marketplace.</span>
          ) : res.buyers.map((b) => (
            <span key={b.id} className="border border-black bg-white px-1.5 py-0.5" data-testid={`match-check-buyer-${b.code}`}>
              {b.firm_name}{b.is_test && <span className="ml-1 text-[9px] uppercase text-amber-800">test</span>}
            </span>
          ))}
          {!res.marketplace && res.buyers.length > 1 && (
            <span className="text-zinc-600">Each visitor is matched to one of these and keeps the same firm.</span>
          )}
        </div>
      )}
      <div className="mt-1 text-[10px] text-zinc-600">Test buyers only match staff previews, never real visitors.</div>
    </div>
  );
};
